<template>
  <div>
    <table class="table">
      <tbody>
      <tr v-for="value, key in quote" v-if="key !== 'uses_franking_machine' && index(key) < 57">
        <td><b>I{{ index(key) }}</b></td>
        <td>{{ key }}</td>
        <td>{{ value }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    name: "quote-info-keys",
    props: ['quote'],
    methods: {
      index(key) {
        let keys = _.keys(this.quote)
        let index = keys.indexOf(key) + 1
        if (index > 14) index--
        return index
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Debug/QuoteInfo/Keys.vue